import Button from "../../../../content/blog/responsive-buttons/Button";
import Experiment from "../../../../content/blog/responsive-buttons/Experiment";
import FinalButton from "../../../../content/blog/responsive-buttons/FinalButton/index.js";
import * as React from 'react';
export default {
  Button,
  Experiment,
  FinalButton,
  React
};